export default "__VITE_ASSET__OHh_BaZAOYh9kalPDhLCJw__"